import { defineComponent as h, ref as y, computed as o, createElementBlock as V, openBlock as I, createVNode as i, unref as r, mergeProps as A } from "vue";
import { RevButtonIcon as k } from "@ds/components/ButtonIcon";
import { RevInputText as w } from "@ds/components/InputText";
import B from "../../icons/generated/IconEyeClosed.vue2.js";
import L from "../../icons/generated/IconEyeOpen.vue2.js";
const g = {
  class: "relative",
  "data-test": "input-password"
}, R = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "InputPassword",
  props: {
    hideAriaLabel: {},
    showAriaLabel: {},
    description: { default: "" },
    error: { default: void 0 },
    id: {},
    label: {},
    modelValue: {},
    disabled: { type: Boolean },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid"],
  setup(e, { emit: d }) {
    const n = e, l = d, t = y(!0), u = () => {
      t.value = !t.value;
    }, s = o(() => t.value ? L : B), c = o(() => t.value ? "password" : "text"), m = o(() => t.value ? n.showAriaLabel : n.hideAriaLabel), p = (a) => {
      l("update:modelValue", a);
    }, v = (a) => {
      l("input", a);
    }, b = (a) => {
      l("invalid", a);
    }, f = () => {
      l("valid");
    };
    return (a, q) => (I(), V("div", g, [
      i(r(w), A({ id: e.id }, a.$attrs, {
        description: e.description,
        disabled: e.disabled,
        error: e.error,
        "has-clear-button": !1,
        label: e.label,
        "model-value": e.modelValue,
        required: e.required,
        type: c.value,
        onInput: v,
        onInvalid: b,
        "onUpdate:modelValue": p,
        onValid: f
      }), null, 16, ["id", "description", "disabled", "error", "label", "model-value", "required", "type"]),
      i(r(k), {
        "aria-label": m.value,
        class: "absolute inset-y-4 right-4 cursor-pointer",
        "data-test": "reveal-button",
        icon: s.value,
        type: "button",
        variant: "secondary",
        onClick: u
      }, null, 8, ["aria-label", "icon"])
    ]));
  }
});
export {
  R as default
};
